<div class="upsell-footer bg-black text-white">
    <div class="upsell-footer__container px-4 py-8 text-sm mx-auto text-center desktop:text-left flex flex-col desktop:flex-row desktop:justify-between gap-8 desktop:py-14 desktop:text-base">
        <img class="upsell-footer__logo mx-auto desktop:mx-0 desktop:flex-shrink-0" src="https://cdn.hartfelt.com/images/Hartfelt-logo-white.svg" alt="Hartfelt">
        <div class="desktop:max-w-2xl">
            <p>Copyright © {{ year }} Hartfelt™.</p>
            <p>These statements have not been evaluated by the Food & Drug Administration.</p>
            <p>These products are not intended to diagnose, treat, cure, or prevent any disease.</p>
            <p>These products are not intended for pets with medical conditions. Use only as directed.</p>
            <p>
                <a target="_blank" href="https://legal.hartfelt.com/terms">Terms & Conditions</a> |
                <a target="_blank" href="https://legal.hartfelt.com/privacy-policy">Privacy Policy</a> |
                <a target="_blank" href="https://legal.hartfelt.com/privacy-policy#Additional-Information-for-California-Residents">CA Privacy Notice</a> |
                <a target="_blank" href="https://hartfelt.com/your-privacy-choices/">Your Privacy Choices</a>
            </p>
            <p class="mt-3 text-xs">*All dogs are unique. Individual results may vary.</p>
        </div> 
    </div> 
</div>